export default __webpack_public_path__ + "static/media/hiking.c830a692.svg";